import { useSelector, shallowEqual } from 'react-redux'

import { DetailsGroup, useReportDetailsGroup } from './useReportDetailsGroup'


export type AllSchoolsDto = Array<{
  school_title: string
  data: {
    personal: number
    common: number
    total: number
  }
}>

export function useReportAllSchoolsDto() {
  const allSchools = useSelector((state: any) => state.reports.subsidies.data.all_schools, shallowEqual)
  const detailsGroup = useReportDetailsGroup()

  if (allSchools && detailsGroup === DetailsGroup.NoGroup) {
    return allSchools as AllSchoolsDto
  }

  return null
}
